<div class="modal-container">
    <h2 mat-dialog-title>{{titleKey | translate}}</h2>

    <mat-dialog-content>
        <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">

            <!-- Email recipients -->
            <app-email-input-with-chips
                [parentForm]="form"
                [placeholder]="'emailShippingLabelView.emailPlaceholder' | translate">
            </app-email-input-with-chips>

            <!-- Shipping Label Type dropdown -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>{{'emailShippingLabelView.shippingLabelLabel' | translate}}</mat-label>
                <mat-select [formControlName]="'selectedShippingLabel'">
                    <mat-option *ngIf="!shippingLabels?.length" [value]="null" disabled>
                        {{'emailShippingLabelView.noShippingLabelsAvailableText' | translate}}
                    </mat-option>
                    <mat-option *ngFor="let sl of shippingLabels" [value]="sl?.procedureId">{{sl.description}}</mat-option>
                </mat-select>
                <mat-error>{{'emailShippingLabelView.shippingLabelRequiredText' | translate}}</mat-error>
            </mat-form-field>

            <!-- Subject field -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>{{'emailShippingLabelView.subjectLabel' | translate}}</mat-label>
                <input matInput [formControlName]="'subject'">
                <mat-error>{{'emailShippingLabelView.subjectRequiredText' | translate}}</mat-error>
            </mat-form-field>

            <!-- Message field -->
            <mat-form-field fxLayout="column" fxLayoutAlign="stretch">
                <mat-label>{{'emailShippingLabelView.messageLabel' | translate}}</mat-label>
                <textarea matInput [formControlName]="'message'" mat-autosize></textarea>
                <mat-error>{{'emailShippingLabelView.messageRequiredText' | translate}}</mat-error>
            </mat-form-field>

        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="close()">{{'emailShippingLabelView.cancelButton' | translate}}</button>
        <button mat-raised-button color="primary" (click)="send()" [disabled]="form.invalid">{{'emailShippingLabelView.sendButton' | translate}}</button>
    </mat-dialog-actions>
</div>
